import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemeListesiv2SpotListesi_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemeListesiv2SpotListesi_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  Get_Date: any[];
  Get_Date_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  YuklemePlan_Get_MasterSpotListe: any[];
  YuklemePlan_Get_MasterSpotListe_dummy: any[];
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  isComp186535Visible: "visible" | "hidden";
  isComp135989Visible: "visible" | "hidden";
  isComp669805Enabled: "enabled" | "disabled";
  isComp100317Enabled: "enabled" | "disabled";
  isCompyuklemelistesiv2spotlistesi_132969AuthorizationVisible:
    | "visible"
    | "hidden";
  isCompyuklemelistesiv2spotlistesi_794080AuthorizationVisible:
    | "visible"
    | "hidden";
}

export class YuklemeListesiv2SpotListesi_ScreenBase extends React.PureComponent<
  IYuklemeListesiv2SpotListesi_ScreenProps,
  any
> {
  yuklemelistesiv2spotlistesi_129888_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2spotlistesi_140956_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2spotlistesi_559033_value_kuikaTableRef: React.RefObject<any>;
  yuklemelistesiv2spotlistesi_44878_value_kuikaDatetimeRef: React.RefObject<any>;
  yuklemelistesiv2spotlistesi_669805_value_kuikaDateRef: React.RefObject<any>;
  yuklemelistesiv2spotlistesi_100317_value_kuikaDateRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "42c20354-3d79-4bce-b495-f036574d5ded",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        {
          Id: 980166,
          PropertyName: "value",
          Value: "Aruna Nakliye Yönetim Portalı",
        },
        { Id: 162294, PropertyName: "value", Value: "YÜKLEME LİSTESİ" },
        { Id: 186535, PropertyName: "label", Value: "Excel Kaydet" },
        { Id: 755618, PropertyName: "value", Value: "TARİH ARALIĞI" },
        { Id: 129888, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 140956, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 111189, PropertyName: "label", Value: "Yenile" },
        { Id: 145261, PropertyName: "title", Value: "İşlemler" },
        { Id: 276952, PropertyName: "title", Value: "Talep Durumu" },
        { Id: 216451, PropertyName: "value", Value: "[datafield:talepdurumu]" },
        { Id: 135989, PropertyName: "title", Value: "Teklif Tutarı" },
        {
          Id: 657357,
          PropertyName: "value",
          Value: "[datafield:tekliftutari]",
        },
        { Id: 543605, PropertyName: "title", Value: "Oluşturma Tarihi" },
        {
          Id: 44878,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 499902, PropertyName: "title", Value: "Tarih" },
        { Id: 669805, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 159875, PropertyName: "title", Value: "Planlanan Tarih" },
        { Id: 100317, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 510557, PropertyName: "title", Value: "Ref Yükleme No" },
        {
          Id: 918217,
          PropertyName: "value",
          Value: "[datafield:referansyuklemeno]",
        },
        { Id: 408516, PropertyName: "title", Value: "Yükleme No" },
        { Id: 307294, PropertyName: "value", Value: "[datafield:yuklemeno]" },
        { Id: 768361, PropertyName: "title", Value: "Araç Tipi" },
        { Id: 804461, PropertyName: "value", Value: "[datafield:aractipi]" },
        { Id: 594310, PropertyName: "title", Value: "Nokta Sayısı" },
        { Id: 96853, PropertyName: "value", Value: "[datafield:noktasayisi]" },
        { Id: 121408, PropertyName: "title", Value: "Toplam Ağırlık" },
        {
          Id: 629871,
          PropertyName: "value",
          Value: "[datafield:toplamagirlik]",
        },
        { Id: 430703, PropertyName: "title", Value: "İl" },
        { Id: 363067, PropertyName: "value", Value: "[datafield:varisil]" },
        { Id: 304534, PropertyName: "title", Value: "İlçe" },
        { Id: 769206, PropertyName: "value", Value: "[datafield:varisilce]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemelistesiv2spotlistesi_129888_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2spotlistesi_140956_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2spotlistesi_559033_value_kuikaTableRef =
      React.createRef();
    this.yuklemelistesiv2spotlistesi_44878_value_kuikaDatetimeRef =
      React.createRef();
    this.yuklemelistesiv2spotlistesi_669805_value_kuikaDateRef =
      React.createRef();
    this.yuklemelistesiv2spotlistesi_100317_value_kuikaDateRef =
      React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      Get_Date: [],
      SetValueOf: "",
      YuklemePlan_Get_MasterSpotListe: [],
      IfThenElse: false,
      isComp186535Visible: "hidden",
      isComp135989Visible: "hidden",
      isComp669805Enabled: "disabled",
      isComp100317Enabled: "disabled",
      isCompyuklemelistesiv2spotlistesi_132969AuthorizationVisible: "visible",
      isCompyuklemelistesiv2spotlistesi_794080AuthorizationVisible: "visible",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "yuklemelistesiv2spotlistesi",
        ""
      );
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemeListesiv2SpotListesiPageInit();
    }
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompyuklemelistesiv2spotlistesi_132969AuthorizationVisible",
      [
        "93545850-b970-5258-d9e0-99fdb6439d19",
        "8d6aca26-54fb-d461-9b81-6cbf4daedc32",
        "Tedarikci",
      ]
    );
    ReactSystemFunctions.hideIsNotAuthorized(
      this,
      "isCompyuklemelistesiv2spotlistesi_794080AuthorizationVisible",
      [
        "9459e43c-c7a1-4bc0-bf4c-db425158076b",
        "5dd30a97-5b3d-4d32-69d1-4079db8ccde8",
        "SuperUser",
        "Operasyon",
      ]
    );

    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2spotlistesi",
      ""
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "yuklemelistesiv2spotlistesi",
      ""
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemeListesiv2SpotListesiPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemeListesiv2SpotListesiPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2SpotListesi/YuklemeListesiv2SpotListesiPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.isComp135989Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("Tedarikci", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.Get_Date = result?.data.get_Date;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2spotlistesi_129888_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].ayIlkGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].ayIlkGun
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2spotlistesi_140956_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.Get_Date !== undefined
          ? stateVars.Get_Date?.length > 0
            ? stateVars.Get_Date[0].aySonGun
            : null
          : this.state.Get_Date?.length > 0
          ? this.state.Get_Date[0].aySonGun
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_129888_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_140956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2SpotListesi/YuklemeListesiv2SpotListesiPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Get_MasterSpotListe =
      result?.data.yuklemePlan_Get_MasterSpotListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiPageInit_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2spotlistesi_162294_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName(
        "TEKLİF - ONAY BEKLEYEN YÜKLEMELER LİSTESİ",
        "string"
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiPageInit_else4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yuklemelistesiv2spotlistesi_162294_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName(
        "TEKLİF ONAYI BEKLEYEN YUKLEMELER LİSTESİ",
        "string"
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      )
    ) {
      isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit_if4();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.YuklemeListesiv2SpotListesiPageInit_else4();
      if (isErrorOccurred) return true;
    }

    stateVars.dataSource_559033 =
      stateVars.YuklemePlan_Get_MasterSpotListe ??
      this.state.YuklemePlan_Get_MasterSpotListe;
    stateVars.isComp135989Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiComponent_834167_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "1"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeListesiv2SpotListesiComponent_834167_onClick1_,
        "YuklemeListesiv2SpotListesi",
        "LeftMenu",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "690718",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2SpotListesiComponent_834167_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiComponent_834167_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].firmaTipi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].firmaTipi
            : null
        ),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemeListesiv2SpotListesi",
        "LeftMenuYukVeren",
        "",
        "7d969ddf-5801-4eb6-b92b-12be35bdd565",
        "375410",
        null,
        "left",
        "true",
        "380px",
        "100vh",
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiComponent_111189_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      FirmaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      BaslangicTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_129888_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisTarihi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_140956_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BagliFirmaId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaId
            : null
        ),
        "Guid"
      ),
      UserRole_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemeListesiv2SpotListesi/YuklemeListesiv2SpotListesiComponent_111189_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_Get_MasterSpotListe =
      result?.data.yuklemePlan_Get_MasterSpotListe;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemeListesiv2SpotListesiComponent_111189_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiComponent_111189_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_559033 =
      stateVars.YuklemePlan_Get_MasterSpotListe ??
      this.state.YuklemePlan_Get_MasterSpotListe;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiComponent_535229_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      )
    ) {
      KuikaAppManager.showSpinner(this);

      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2DetayTedarikci",
        "YuklemeId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_559033_value",
            "id"
          ),
          "Guid"
        )
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.YuklemeListesiv2SpotListesiComponent_535229_onClick1_,
        "YuklemeListesiv2SpotListesi",
        "YuklemeListesiv2DetayTedarikci",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YuklemeListesiv2SpotListesiComponent_535229_onClick1_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  YuklemeListesiv2SpotListesiComponent_535229_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].rolName
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].rolName
            : null
        ),
        "Tedarikci"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2Detaylar",
        "YuklemeId",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.value(
            this,
            "yuklemelistesiv2spotlistesi_559033_value",
            "id"
          ),
          "Guid"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "YuklemeListesiv2Detaylar",
        "EditMode",
        ReactSystemFunctions.convertToTypeByName(false, "boolean")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        undefined,
        "YuklemeListesiv2SpotListesi",
        "YuklemeListesiv2Detaylar",
        "",
        "currentPage",
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiComponent_132969_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanSpotTeklifVer",
      "YuklemeId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2spotlistesi_559033_value",
          "id"
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanSpotTeklifVer",
      "YuklemeNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2spotlistesi_559033_value",
          "yuklemeNo"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanSpotTeklifVer",
      "TalepId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2spotlistesi_559033_value",
          "talepId"
        ),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemeListesiv2SpotListesi",
      "YuklemePlanSpotTeklifVer",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "923099",
      null,
      null,
      "true",
      "800px",
      "70vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YuklemeListesiv2SpotListesiComponent_794080_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanSpotTeklifler",
      "YuklemeId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2spotlistesi_559033_value",
          "id"
        ),
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "YuklemePlanSpotTeklifler",
      "YuklemeNo",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "yuklemelistesiv2spotlistesi_559033_value",
          "yuklemeNo"
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "YuklemeListesiv2SpotListesi",
      "YuklemePlanSpotTeklifler",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [690718, 375410, , , 923099] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemeListesiv2SpotListesiPageInit();
    }
    if (diId == 690718) {
      isErrorOccurred =
        await this.YuklemeListesiv2SpotListesiComponent_834167_onClick1_();
      if (isErrorOccurred) return true;
    }
  }
}
